"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorialCarouselSlide = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _ArticleBox = require("../ArticleBox");
var _Carousel = require("../Carousel");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const EditorialCarouselSlide = ({
  data,
  labelRead,
  labelWatch,
  minWidth
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Carousel.CarouselSlide, {
    minWidth: minWidth,
    testId: getTestId(_constants.EDITORIAL_CAROUSEL_SLIDE),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArticleBox.ArticleBox, {
      image: data.image,
      title: data.title,
      categoryTitle: data.categoryTitle,
      introText: data.introText,
      isVideoArticle: data.isVideoArticle,
      labelRead: labelRead,
      labelWatch: labelWatch,
      link: data.link,
      articleType: data.articleType,
      published: data.published,
      products: data.products,
      className: data.className
    })
  }, data.link?.relativeUrl ?? '');
};
exports.EditorialCarouselSlide = EditorialCarouselSlide;
